import type { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { mergeSx } from '@/utils/mergeSx';

import { BasicChip } from './BasicChip';
import { chipsStyles as sx } from './Chips.styles';

type Props = {
	indicateError?: boolean;
	customSx?: {
		root?: SxProps<Theme>;
	};
};

export const RequiredChip = ({ indicateError, customSx }: Props) => {
	const { t } = useTranslation();

	return (
		<BasicChip
			label={t('Required')}
			customSx={mergeSx(customSx?.root, indicateError && sx.indicateError)}
		/>
	);
};
